import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Logo } from "../../assets/imageAssets";
import TextLink from "../../components/Buttons/textLink";
import { profiles_req } from "../../api/profiles.api";

const Footer = () => {
  const [data, setData] = useState(null);
  const getProfiles = async () => {
    const response = await profiles_req();

    setData(response?.result);
  };

  useEffect(() => {
    getProfiles();
  }, []);
  return (
    <div className="footer">
      <div className="footer__top">
        <div className="container">
          <div className="flex">
            <div className="footer__top__logo-box">
              <Link
                to={"/"}
                className="logo"
              >
                <img
                  src={Logo}
                  alt="Back to Reality"
                />
              </Link>
              <p className="medium-text text-color-grey">
                Gain personalized insights into real life — from well-being to
                wages — based on trusted data.
              </p>
            </div>
            <div className="footer__top__links-box">
              <span>Product</span>
              <ul>
                <li>
                  <TextLink
                    text={"How It Works"}
                    href={"/"}
                  />
                </li>
                {/* <li>
                            <TextLink text={'Pricing'} />
                        </li> */}
                <li>
                  <TextLink
                    href={"/privacy-policy"}
                    text={"Privacy Policy"}
                  />
                </li>
                <li>
                  <TextLink
                    href={"/terms"}
                    text={"Terms & Conditions"}
                  />
                </li>
              </ul>
            </div>
            <div className="footer__top__links-box">
              <span>Profiles</span>
              <ul>
                {data?.map((item) => (
                  <li>
                    <TextLink
                      text={item.name}
                      href={`/profiles/${item.id}/topics`}
                    />
                  </li>
                ))}
              </ul>
            </div>
            {/* <div className="footer__top__links-box">
              <span>Popular topics</span>
              <ul>
                <li>
                  <TextLink text={"Hourly Wages"} />
                </li>
                <li>
                  <TextLink text={"Life Scores"} />
                </li>
                <li>
                  <TextLink text={"Household Size"} />
                </li>
                <li>
                  <TextLink text={"Job Confidence"} />
                </li>
                <li>
                  <TextLink text={"Well-being Stats"} />
                </li>
              </ul>
            </div> */}
          </div>
        </div>
      </div>
      <div className="footer__bottom">
        <div className="container">
          <p className="medium-text">
            © 2025 BackToReality. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
